import React, { useEffect, useState } from 'react';
import { array, bool, func, number, object, shape, string } from 'prop-types';
import SurveyMigrations from './SurveyMigrations';
import { withRouter } from 'react-router';
import './DataCutMigrationDetails.scss';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as dataCutMigrationChangeActionCreators from '../actions/DataCutMigrationActions';
import { connect } from 'react-redux';
import Search from 'ps-components/Search/Search';
import Dropdown from 'ps-components/Dropdown/Dropdown';
import Table from 'ps-components/Table/Table/Table';
import classnames from 'classnames';
import TableBody from 'ps-components/Table/TableBody/TableBody';
import AdvancedCell from 'ps-components/AdvancedTable/AdvancedCell';
import AdvancedRow from 'ps-components/AdvancedTable/AdvancedRow';
import Popover from 'ps-components/Popover/Popover';
import { Segmented, Tooltip } from 'ps-design';
import ReactSelect from 'ps-components/ReactSelect/ReactSelect';

function DataCutMigrationDetails(props) {
  const [searchText, setSearchText] = useState('');
  const [editRow, setEditRow] = useState({});
  const [showTooltip, setShowTooltip] = useState(false);
  //User Selected Data Cut Options from Available Data Cuts Dropdown
  const [dataCutOptions, setDataCutOptions] = useState({
    surveyOption: '',
    alternativeDataCutOne: '',
    alternativeDataCutTwo: ''
  });
  const [renderPopover, setRenderPopover] = useState(false);
  const [showAllDataCuts, setShowAllDataCuts] = useState(false);
  const currentMigrationId = parseInt(props.match.params.migrationId);
  const currentMigration = props.dataCutSurveys.find(selectedSurvey => selectedSurvey.sessionPk === currentMigrationId);
  const { defaultBenchmarkYear } = props;
  const newSurveyYear = parseInt(defaultBenchmarkYear) + 1;

  useEffect(() => {
    if (props.isAgingReducerLoaded) {
      props.actions.getDataCutSurveys(defaultBenchmarkYear, newSurveyYear, props?.migrationLandingSearch);
      props.actions.getMigrationDetails(currentMigrationId);
      props.actions.selectDataCutDropdown(currentMigration?.newSurveyCode);
    }
  }, [props.isAgingReducerLoaded]);

  useEffect(() => {
    if (props.isAgingReducerLoaded) {
      props.actions.getMigrationDetails(currentMigrationId, searchText);
      props.actions.selectDataCutDropdown(currentMigration?.newSurveyCode);
    }
    setSearchText('');
    resetDataCutOptions();
  }, [currentMigrationId, currentMigration]);

  function searchOnChange(event) {
    setSearchText(event?.target?.value);
  }

  function searchOnClick() {
    setSearchText('');
    props.actions.getMigrationDetails(currentMigrationId);
  }

  function searchOnKeyDown(event) {
    if (event.key === 'Enter') {
      setSearchText(searchText);
      props.actions.getMigrationDetails(currentMigrationId, searchText);
    }
  }

  function searchOnSearch() {
    setSearchText(searchText);
    props.actions.getMigrationDetails(currentMigrationId, searchText);
  }

  const exceptionDropdownOptions = [
    'Preserve With Current Weighting',
    'Preserve With 0 Weighting',
    'Leave Them As Exceptions',
    'Do Not Migrate The Survey'
  ];

  const exceptionDecisions = {
    PRESERVE_WEIGHT: 'preserve_weight',
    ZERO_WEIGHT: 'zero_weight',
    LEAVE_EXCEPTION: 'leave_exception',
    NO_MIGRATE: 'no_migrate'
  };

  function handleException(exceptionDecision) {
    switch (exceptionDecision) {
      case exceptionDecisions.PRESERVE_WEIGHT:
        return exceptionDropdownOptions[0];
      case exceptionDecisions.ZERO_WEIGHT:
        return exceptionDropdownOptions[1];
      case exceptionDecisions.NO_MIGRATE:
        return exceptionDropdownOptions[3];
      case exceptionDecisions.LEAVE_EXCEPTION:
        return exceptionDropdownOptions[2];
      default:
        return exceptionDropdownOptions[0];
    }
  }

  function handleToggle() {
    setShowAllDataCuts(!showAllDataCuts);
  }

  function handleExceptionChange(decision) {
    const { defaultBenchmarkYear } = props;
    const newSurveyYear = parseInt(defaultBenchmarkYear) + 1;
    if (decision === exceptionDropdownOptions[2]) {
      decision = exceptionDecisions.LEAVE_EXCEPTION;
    }
    if (decision === exceptionDropdownOptions[1]) {
      decision = exceptionDecisions.ZERO_WEIGHT;
    }
    if (decision === exceptionDropdownOptions[3]) {
      decision = exceptionDecisions.NO_MIGRATE;
    }
    if (decision === exceptionDropdownOptions[0]) {
      decision = exceptionDecisions.PRESERVE_WEIGHT;
    }

    const migration = [
      {
        migrationId: currentMigrationId,
        exceptionDecision: decision
      }
    ];
    props.actions.updateExceptionDecision(migration, migration).then(() => {
      props.actions.getDataCutSurveys(defaultBenchmarkYear, newSurveyYear);
    });
  }

  function handleDataCutSave(dataCut) {
    props.actions
      .updateDataCutOptions(
        currentMigrationId,
        dataCut.jobScope,
        dataCutOptions.surveyOption !== '' ? dataCutOptions.surveyOption : dataCut.firstChoice,
        dataCutOptions.alternativeDataCutOne !== '' ? dataCutOptions.alternativeDataCutOne : dataCut.secondChoice,
        dataCutOptions.alternativeDataCutTwo !== '' ? dataCutOptions.alternativeDataCutTwo : dataCut.thirdChoice
      )
      .then(() => {
        props.actions.processDataCutOptions(currentMigrationId, dataCut.jobScope);
        props.actions.getDataCutSurveys(defaultBenchmarkYear, newSurveyYear, '', '', false);
        props.actions.getMigrationDetails(currentMigrationId);
        resetDataCutOptions();
      });
  }

  function handleCancel() {
    setEditRow({});
    resetDataCutOptions();
  }

  function resetDataCutOptions() {
    setDataCutOptions({ surveyOption: '', alternativeDataCutOne: '', alternativeDataCutTwo: '' });
  }

  const currentDataCuts = showAllDataCuts
    ? props.dataCuts
    : props.dataCuts.filter(dataExceptions => dataExceptions.dataCutOnlyExceptions > 0);

  const renderDataCutRows = () => {
    const defaultOption = '-Select-';
    let dropdownItems = props.dataCutOptions.map(option => {
      return { label: option.name, value: option.name };
    });
    dropdownItems.unshift({ label: defaultOption, value: null });

    const renderEmptyState = dropdownItems.length > 1 ? defaultOption : 'No Data Cuts Found';

    function handleDropdownText(selectedItem, currentItem) {
      if (selectedItem === null) {
        return { label: defaultOption, value: null };
      }
      if (selectedItem) {
        return { label: selectedItem, value: selectedItem };
      }
      if (currentItem) {
        return { label: currentItem, value: currentItem };
      }
    }
    const userOptionChosen =
      dataCutOptions.surveyOption !== '' ||
      dataCutOptions.alternativeDataCutOne !== '' ||
      dataCutOptions.alternativeDataCutTwo !== '';
    return currentDataCuts.map(dataCut => {
      const hasDataCutException = dataCut.dataCutOnlyExceptions > 0;
      const hasPrimaryDataCutMatch = dropdownItems.some(option => option.value === dataCut.jobScope);
      const isSameAsPrimary =
        dataCut.jobScope === dataCut.firstChoice || dataCut.jobScope === dataCutOptions.surveyOption;

      const renderFirstOption = () => {
        if (isSameAsPrimary || hasPrimaryDataCutMatch) {
          return 'Same as primary';
        }
        if (hasDataCutException && !dataCut.firstChoice) {
          return 'Primary data cut not available';
        }
        if (dataCut.firstChoice) {
          return dataCut.firstChoice;
        } else {
          return 'Not Set';
        }
      };
      return (
        <AdvancedRow key={`data-cut-row-${dataCut.jobScope}`} className="data-cut-row">
          <AdvancedCell className="jobscope__cell" width="25%">
            <div className="jobscope-one">
              <span>{dataCut.jobScope}</span>
            </div>
          </AdvancedCell>
          <AdvancedCell className="primary__cell" width="24%">
            {dataCut !== editRow && (
              <div
                className={classnames('jobscope-two', {
                  'orange-highlight-light': hasDataCutException && !dataCut.firstChoice,
                  faded: !dataCut.firstChoice && !hasDataCutException && !isSameAsPrimary && !hasPrimaryDataCutMatch
                })}
              >
                {renderFirstOption()}
              </div>
            )}
            {dataCut === editRow && (
              <div className="data-cut-row__dropdown-wrapper">
                <ReactSelect
                  className="data-cut-migration__react-select"
                  value={handleDropdownText(dataCutOptions.surveyOption, dataCut.firstChoice)}
                  placeholder={renderEmptyState}
                  options={dropdownItems}
                  onChange={selectedItem =>
                    setDataCutOptions(prevState => ({
                      ...prevState,
                      surveyOption: selectedItem.label !== defaultOption ? selectedItem.value : null
                    }))
                  }
                />
              </div>
            )}
          </AdvancedCell>
          <AdvancedCell className="alt-one__cell" width="24%">
            {dataCut !== editRow && (
              <div className={classnames('jobscope-three', { faded: !dataCut.secondChoice })}>
                {dataCut.secondChoice || 'Not Set'}
              </div>
            )}
            {dataCut === editRow && (
              <div className="data-cut-row__dropdown-wrapper">
                <ReactSelect
                  className="data-cut-migration__react-select"
                  value={handleDropdownText(dataCutOptions.alternativeDataCutOne, dataCut.secondChoice)}
                  placeholder={renderEmptyState}
                  options={dropdownItems}
                  onChange={selectedItem =>
                    setDataCutOptions(prevState => ({
                      ...prevState,
                      alternativeDataCutOne: selectedItem.label !== defaultOption ? selectedItem.value : null
                    }))
                  }
                />
              </div>
            )}
          </AdvancedCell>
          <AdvancedCell className="alt-two__cell" width="27%">
            {dataCut !== editRow && (
              <div className={classnames('jobscope-four', { faded: !dataCut.thirdChoice })}>
                <span>{dataCut.thirdChoice || 'Not Set'}</span>
                {hasDataCutException && <a onClick={() => setEditRow(dataCut)}>Edit</a>}
              </div>
            )}
            {dataCut === editRow && (
              <div className="data-cut-row__dropdown-wrapper-alt-2">
                <ReactSelect
                  className="data-cut-migration__react-select"
                  value={handleDropdownText(dataCutOptions.alternativeDataCutTwo, dataCut.thirdChoice)}
                  placeholder={renderEmptyState}
                  options={dropdownItems}
                  onChange={selectedItem =>
                    setDataCutOptions(prevState => ({
                      ...prevState,
                      alternativeDataCutTwo: selectedItem.label !== defaultOption ? selectedItem.value : null
                    }))
                  }
                />
                <div className="data-cut-save__row">
                  <a onClick={handleCancel} className="data-cut-row__cancel">
                    Cancel
                  </a>
                  <button
                    className={classnames('data-cut-save__button', {
                      'data-cut-save__button-active': userOptionChosen
                    })}
                    onClick={() => handleDataCutSave(dataCut)}
                    disabled={!userOptionChosen}
                  >
                    Save
                  </button>
                </div>
              </div>
            )}
          </AdvancedCell>
        </AdvancedRow>
      );
    });
  };

  const altOneToolTip = (
    <Tooltip
      className="migration-alternative-one-tooltip"
      hoverText="Alternative data cut 1 will be used for the matches when the designated data cut for the new survey doesn’t have data"
      id="data-cut-migration__alternative-one-tooltip"
      position="top"
    />
  );

  const altTwoToolTip = (
    <Tooltip
      className="migration-alternative-two-tooltip"
      hoverText={
        'Alternative data cut 2 will be used for the matches when neither the designated data cut nor the alternative data cut 1 for the new survey has data'
      }
      id={'data-cut-migration__alternative-two-tooltip'}
      position="top"
    />
  );

  const exceptionDecisionDescriptions = [
    {
      header: 'Preserve with current/zero weighting',
      description:
        'Match exceptions will be migrated to the new benchmark year using the same survey jobs and data cuts in the old survey, with current/zero weighting. Matches will be aged according to the aging factor(s) set up in your aging table.'
    },
    {
      header: 'Leave them as exceptions',
      description: 'Matches will not be migrated into the new benchmark year.'
    },
    {
      header: 'Do not migrate the survey',
      description:
        'None of the matches made to this survey in the current benchmark year will be migrated into the new benchmark year (but will remain in the previous benchmark year).'
    }
  ];

  const handlePopover = (event) => {
    event?.stopPropagation();
    setRenderPopover(!renderPopover);
  };

  const popoverTrigger = (
    <div onClick={handlePopover} className="icon-reverse icon-circle">
      <i className="icon-info" />
    </div>
  );

  const exceptionDecisionPopover = (
    <span className="data-cut-migration__popover-wrapper">
      {renderPopover && (
        <Popover
          popoverClassnames="data-cut-migration__popover-total-exceptions"
          relativeElement={document.querySelector('span#survey-exception-decision')}
          display={true}
          arrowAlign="center"
          togglePopover={handlePopover}
        >
          {exceptionDecisionDescriptions.map(item => (
            <div className="data_cut_migration__popover-content-wrapper" key={item.header}>
              <p className="data_cut_migration__popover-header">{item.header}</p>
              <p className="data_cut_migration__popover-description">{item.description}</p>
            </div>
          ))}
        </Popover>
      )}
    </span>
  );

  const notMigrated = props.dataCuts.filter(dataExceptions => dataExceptions.dataCutOnlyExceptions > 0).length;
  const numOfExceptions = `${currentMigration?.dataCutOnlyExceptions}  `;
  const handleRows =
    currentDataCuts.filter(dataCut => dataCut.jobScope).length > 0 ? (
      renderDataCutRows()
    ) : (
      <p className="data-cut__empty-text">No Results Found</p>
    );

  const mainDropdownOptions = ['All Surveys', 'Surveys with Exceptions', 'Surveys with no Exceptions'];
  const filterSurveys =
    props.dropdownFilter === mainDropdownOptions[0]
      ? props.dataCutSurveys
      : props.dropdownFilter === mainDropdownOptions[2]
      ? props.noExceptionSurveys
      : props.exceptionOnlySurveys;

  return (
    <div className="data-cut-migration-details__container">
      {!props.dataCutSurveysLoading && (
        <React.Fragment>
          <div className="survey-migrations__list">
            <div className="back__link">
              <Link to="/market-analysis/data-cut-migration">
                <i className="icon-reply" />
                Back to survey list
              </Link>
            </div>
            <SurveyMigrations surveyMigrations={filterSurveys} currentMigrationId={currentMigrationId} />
          </div>
          <div className="survey-migrations__data">
            <div className="current-survey-migration-header">
              <div className="current-survey-migration-wrapper">
                <div className="current-survey-migration-header-current">
                  <span className="survey-code pxl-text-muted pxl-text-small">{currentMigration?.curSurveyCode}</span>
                  <span className="survey-title">{currentMigration?.curSurveyTitle}</span>
                </div>
                <div className="icon-right-wrapper">
                  <i className="icon-right" />
                </div>
                <div className="current-survey-migration-header-new">
                  <span className="survey-code pxl-text-muted pxl-text-small">{currentMigration?.newSurveyCode}</span>
                  <span className="survey-title">{currentMigration?.newSurveyTitle}</span>
                </div>
              </div>
              <div className="current-exceptions-header">
                <span className="exception-main-header">Exceptions</span>
                <p className="exceptions-header-row">
                  <span className="number-exceptions orange-highlight-light">{numOfExceptions}</span>
                  out of {props?.totalDataCutOnlyExceptions}
                </p>
              </div>
            </div>
            <div className="survey-migration-header-row">
              <Segmented
                className="pxl-segmented-secondary"
                onChange={handleToggle}
                options={[
                  {
                    text: `Cannot be migrated (${notMigrated})`,
                    value: showAllDataCuts
                  },
                  { text: `All Data Cuts (${props.dataCuts.length})`, value: !showAllDataCuts }
                ]}
                value={false}
              />
            </div>
            <div className="survey-search-row">
              <Search
                className="survey-data-cut__search"
                placeholder="Search Primary Data Cuts"
                onChange={searchOnChange}
                onClick={searchOnClick}
                onKeyDown={searchOnKeyDown}
                onSearch={searchOnSearch}
                value={searchText}
              />
            </div>
            <div className="survey-cut-table-container">
              <div className="survey-cut-table-header">
                <Table>
                  <TableBody>
                    <AdvancedRow className="survey-header-row">
                      <AdvancedCell width="25%">Primary Data Cut</AdvancedCell>
                      <AdvancedCell width="24%">{`for ${currentMigration?.newSurveyCode}`}</AdvancedCell>
                      <AdvancedCell width="24%" onClick={() => setShowTooltip(!showTooltip)}>
                        Alternative Data Cut 1 {altOneToolTip}
                      </AdvancedCell>
                      <AdvancedCell width="27%">Alternative Data Cut 2 {altTwoToolTip}</AdvancedCell>
                    </AdvancedRow>
                  </TableBody>
                </Table>
              </div>
              <Table>
                <TableBody>{handleRows}</TableBody>
              </Table>
            </div>
            <div className="survey-exception-decision-container">
              <span id="survey-exception-decision">Decision for exceptions {popoverTrigger}</span>
              {exceptionDecisionPopover}
              <Dropdown
                className="survey-exception-decision__dropdown"
                dropdownItems={exceptionDropdownOptions}
                text={handleException(currentMigration?.exceptionDecision)}
                itemOnClick={handleExceptionChange}
                disabled={false}
              />
            </div>
          </div>
        </React.Fragment>
      )}
    </div>
  );
}

DataCutMigrationDetails.propTypes = {
  dataCutSurveys: array,
  dataCutSurveysLoading: bool,
  match: object,
  defaultBenchmarkYear: number,
  isAgingReducerLoaded: bool,
  dataCuts: array,
  dataCutsLoading: bool,
  dataCutsError: bool,
  dataCutsSuccess: bool,
  totalDataCutsWithDataCutOnlyExceptions: number,
  totalDataCutOnlyExceptions: number,
  dataCutOptions: array,
  dropdownFilter: string,
  exceptionOnlySurveys: array,
  noExceptionSurveys: array,
  actions: shape({
    getDataCutSurveys: func,
    getMigrationDetails: func,
    updateExceptionDecision: func,
    selectDataCutDropdown: func,
    updateDataCutOptions: func,
    processDataCutOptions: func
  })
};

const mapStateToProps = ({ dataCutMigration, aging }) => ({
  ...dataCutMigration,
  defaultBenchmarkYear: aging.benchmarkYear,
  isAgingReducerLoaded: aging.loaded
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      ...dataCutMigrationChangeActionCreators
    },
    dispatch
  )
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DataCutMigrationDetails));
